import OSlateEditor from '@/libs/slate-editor'
import { Button, Form, Input, Row } from 'antd'
import React, { memo } from 'react'

interface TermsFormProps {
  terms?: any
  onSave: (values) => void
  onCancel: () => void
}

export default memo<TermsFormProps>(function TermsForm(props) {
  const [form] = Form.useForm()
  const { terms, onSave, onCancel } = props

  if (!terms) {
    return null
  }

  return (
    <Form form={form} initialValues={terms} autoComplete='off' layout='vertical' onFinish={onSave}>
      <Form.Item name='name' label='Name' rules={[{ required: true, message: 'Please enter terms name' }]}>
        <Input type='text' />
      </Form.Item>

      <Form.Item name='version' label='Version' rules={[{ required: true, message: 'Please enter terms version' }]}>
        <Input type='text' />
      </Form.Item>

      <div
        onClick={(e) => {
          e.preventDefault()
        }}
      >
        <Form.Item name='content' rules={[{ required: true, message: 'Please enter terms content' }]}>
          <OSlateEditor key={terms?.content} value={terms?.content} />
        </Form.Item>
      </div>

      <Row justify={'end'}>
        <Button htmlType='button' type='default' className={'mr-2'} onClick={onCancel}>
          Cancel
        </Button>

        <Button htmlType='submit' type='primary'>
          Save
        </Button>
      </Row>
    </Form>
  )
})
